import ApolloClient from "apollo-boost";
import fetch from "isomorphic-fetch";

const API = process.env.BACKEND_URL || "https://api.zolt.com.au/";

export const client = new ApolloClient({
    uri: `${API}graphql.api`,
    fetch
})